import { Reveal } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

export function MissionSection() {
  const { t } = useLang();
  return (
    <section id="mission" data-testid="mission-section" className="relative z-10 bg-[#0a0a0a] py-24 md:py-36 border-y border-white/5">
      <div className="mx-auto max-w-[1100px] px-5 md:px-10">
        <Reveal className="max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">{t("mission.overline")}</span>
          <h2 className="font-display font-bold tracking-[-0.02em] text-white text-4xl md:text-5xl lg:text-6xl mt-5 leading-[1.03]">
            {t("mission.heading")}
          </h2>
          <p className="mt-7 text-lg md:text-xl text-zinc-400 leading-relaxed">{t("mission.body")}</p>
        </Reveal>
      </div>
    </section>
  );
}
